import KapHasInsurancePage from "./KapHasInsurancePage"

export default KapHasInsurancePage
